import styled from "styled-components";

export const Container = styled.div`
  background: ${(props) => props.theme.background.default};
  opacity: 0;
  padding: 100px 0 90px;
  @media (max-width: 1024px) {
    padding: 100px 25px 90px;
  }

  .container {
    max-width: 1080px;
    margin: 0 auto;
    height: 100%;

    .title {
      font-family: "DM Sans";
      font-weight: 700;
      font-size: 24px;
      color: ${(props) => props.theme.color.default};
    }

    .subTitle {
      color: ${(props) => props.theme.color.default};
      font-family: "Noto Sans KR";
      font-weight: 500;
      font-size: 44px;
      line-height: 77px;
      margin: 20px 0 55px;

      span {
        color: ${(props) => props.theme.color.active};
        font-weight: 700;
      }

      @media (max-width: 768px) {
        font-size: 28px;
        line-height: 35px;
      }
      /* @media (max-width: 450px) {
        font-size: 30px;
        line-height: 40px;
      } */
      .item--sub__title {
        display: inline;
        @media (max-width: 540px) {
          display: inline-block;
        }
      }
    }

    .container-content {
      display: flex;
      align-items: flex-start;
      @media (max-width: 900px) {
        flex-direction: column;
      }

      .left-container {
        max-width: 410px;
        margin-right: 15px;
        @media (max-width: 1024px) {
          max-width: 325px;
        }
        @media (max-width: 900px) {
          max-width: 100%;
          margin-right: 0;
        }
        .content {
          font-family: "Noto Sans KR";
          text-decoration-line: underline;
          font-weight: 400;
          font-size: 28px;
          line-height: 39px;
          color: ${(props) => props.theme.color.active};
          margin-bottom: 25px;
          span {
            font-weight: 700;
            font-family: "Noto Sans KR Bold";
          }
          @media (max-width: 768px) {
            font-size: 24px;
            line-height: 32px;
          }
        }

        .sub-content {
          color: ${(props) => props.theme.color.default};
          font-family: "Noto Sans KR";
          font-weight: 400;
          font-size: 22px;
          line-height: 29px;
          @media (max-width: 900px) {
            margin-bottom: 50px;
          }
          @media (max-width: 768px) {
            font-size: 18px;
            line-height: 25px;
          }
        }
      }
      .wp-img {
        position: relative;
        width: calc(100% - 425px);
        min-height: 250px;
        @media (max-width: 1024px) {
          width: calc(100% - 350px);
        }
        @media (max-width: 900px) {
          display: none;
        }

        .cycle {
          width: 250px;
          height: 250px;
          background: #f3f1ed;
          border: 3px solid #48b5b5;
          border-radius: 50%;
          filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          @media (max-width: 1024px) {
            width: 230px;
            height: 230px;
          }
          .name-cycle {
            font-family: "Noto Sans KR";
            font-weight: 400;
            font-size: 18px;
            text-align: center;
            color: #5b5b5b;
            margin-bottom: 25px;
          }
          .money-cycle {
            font-family: "Montagu Slab Bold";
            font-weight: 600;
            font-size: 60px;
            letter-spacing: -0.02em;
            color: #48b5b5;
            @media (max-width: 1024px) {
              /* font-size: 60px; */
            }
            span {
              color: #48b5b5;
              font-family: "Noto Sans KR";
              font-weight: 900;
              font-size: 25px;
              transform: translateY(-17px);
              display: inline-block;
              @media (max-width: 1024px) {
                /* font-size: 30px; */
              }
            }
          }
        }

        .img-about {
          z-index: 3;
          position: absolute;
          left: 0;
          top: 0;
        }

        .img-about1 {
          position: absolute;
          left: 32%;
          top: 0;
          z-index: 2;
        }

        .img-about2 {
          position: absolute;
          right: 0;
          top: 0;
          z-index: 1;
        }
      }

      .wp-img__eng .cycle {
        .name-cycle {
          @media (max-width: 1920px) {
            font-size: 16px;
            max-width: 160px;
          }
        }
        .money-cycle {
          @media (max-width: 1920px) {
            font-size: 45px;
            span {
              font-size: 20px;
            }
          }
          /* @media (max-width: 1024px) {
            font-size: 50px;
            span {
              font-size: 25px;
            }
          } */
        }
      }

      .img-mobile {
        width: 100%;
        text-align: center;
        display: none;
        @media (max-width: 900px) {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        img {
          width: 100%;
          max-width: 350px;
          object-fit: cover;
        }
      }
    }
    .icon-down {
      display: none;
      @media (max-width: 1024px) {
        display: block;
        margin: 50px auto 0;
        width: 100%;
        max-width: 74px;
      }
    }
  }

  &.container-animation {
    opacity: 1;

    .title {
      animation: 0.5s ease 0s normal forwards 1 fadeIn;
    }

    .subTitle {
      animation: 0.5s ease 0s normal forwards 1 fadeIn;
    }

    .container-content {
      .content {
        animation: 0.5s ease 0s normal forwards 1 fadeIn;
      }

      .sub-content {
        animation: 0.5s ease 0s normal forwards 1 fadeIn;
      }

      .wp-img {
        .img-about {
          animation: 0.7s ease 0s normal forwards 1 fadeIn;
        }

        .img-about1 {
          animation: 0.9s ease 0s normal forwards 1 fadeIn;
        }

        .img-about2 {
          animation: 1.1s ease 0s normal forwards 1 fadeIn;
        }
      }
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    66% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
